module.exports = __webpack_public_path__ + "img/Verified.d1ef60f7.png";